<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// import en from 'element-plus/es/locale/lang/en'
// 后续根据需求添加国际化语言切换处理

// 忽略窗口频繁重计算错误
window.addEventListener('error', e => {
  if (e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation()
  }
})
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
</style>
